import { AUTOCOMPLETE_ATTRS, TEXTFIELD_ATTRS } from '@/shared/constants/invoiceParameter/DefaultConstants';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import InvoiceParametersRules from '@/components/InvoiceParameters/rules/InvoiceParametersRules';
import { FILTER_COL } from '@/shared/constants/invoiceParameter/FilterConstants';
import GenericFunctionsMixin from '../genericFunctions/genericFunctionsMixin';
import VerifyRoutesMixin from '../routeManagement/verifyRoutesMixin';
import Functions from '@/shared/functions/functions';
import { mapActions, mapGetters } from 'vuex';
import Rules from '@/shared/validators/formRules';
import Formatters from '@/shared/formatters/formatters';
export default {
  name: 'InvoiceParametersMixin',
  data: () => ({
    formatter: null,
    rule: null,
  }),
  mixins: [
    AuthorityManagementMixin,
    InvoiceParametersRules,
    GenericFunctionsMixin,
    VerifyRoutesMixin,
  ],
  methods: {
    ...mapActions({
      updateEntityLevel: 'invoice-parameter/updateEntityLevel',
    }),
    getEntityLevelName(entityLevel) {
      switch(entityLevel) {
        case 'CARRIER':
          return 'Operadora';
        case 'FINANCIAL_GROUP':
          return 'Grupo Financeiro';
        case 'CONTRACT':
          return 'Contrato';
        case 'SUB_CONTRACT':
          return 'Subcontrato';
      }
    },
    convertText(text) {
      return this.func.convertText(text);
    },
    getConfigValue(value, valueType) {
      switch(valueType) {
        case 'BOOLEAN':
          return value ? 'Sim' : 'Não';
        case 'STRING':
          return value;
        case 'INTEGER':
          return String(value);
        case 'DECIMAL':
          const rawFloat = String(value).replace('.', ',');
          return rawFloat;
        default:
          const valueTypeObj = this.valueTypes.find(vt => vt.key === valueType);
          const valueOption = valueTypeObj && valueTypeObj.options && valueTypeObj.options.find(opt => opt.key === value);
          return valueOption.description;
      }
    },
    getOptionsDescription(optionsSelected, valueType) {
      if (!Array.isArray(optionsSelected) || optionsSelected.length <= 1) return '';

      const valueTypeObj = this.valueTypes.find(vt => vt.key === valueType);
      if (!valueTypeObj || !Array.isArray(valueTypeObj.options)) return '-';

      const selectedKeys = optionsSelected.slice(1);
      const descriptions = selectedKeys
      .map(optionKey => {
        const option = valueTypeObj.options.find(opt => opt.key === optionKey);
        return option ? this.convertText(option.description) : null;
      })
      .filter(Boolean);

      return descriptions.length > 0 ? descriptions.join(', ') : '';
    },
    isList(valueType) {
      return !['STRING', 'INTEGER', 'BOOLEAN', 'DECIMAL'].includes(valueType);
    },
    isString(valueType) {
      return valueType === "STRING";
    },
    isInteger(valueType) {
      return valueType === "INTEGER";
    },
    isDecimal(valueType) {
      return valueType === "DECIMAL";
    },
    isBoolean(valueType) {
      return valueType === "BOOLEAN";
    },
    formClosed() {
      return this.isCreating === false && this.isUpdating === false && this.isCopying === false;
    }
  },
  computed: {
    ...mapGetters({
      step: 'invoice-parameter/invoiceParameterStep',
      valueTypes: 'invoice-parameter/valueTypes',
      isCreating: 'invoice-parameter/isCreating',
      isUpdating: 'invoice-parameter/isUpdating',
      isCopying: 'invoice-parameter/isCopying',
      entities: 'invoice-parameter/entities',
    }),
    autocompleteAttrs() {
      return AUTOCOMPLETE_ATTRS;
    },
    textFieldAttrs() {
      return TEXTFIELD_ATTRS;
    },
    colAttrs() {
      return FILTER_COL;
    },
    inLevelSelectionStep() {
      return this.step === 1;
    },
    hasEntities() {
      return this.entities && this.entities.length > 0;
    },
  },
  created() {
    this.formatter = new Formatters();
    this.func = new Functions();
    this.rule = new Rules();
  }
}